import GetFileByExternalIdRequestModelBase from '../_generated/modelBases/get-file-by-external-id-request-model-base';

export default class GetFileByExternalIdRequestModel extends GetFileByExternalIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
